import {useContext} from '@nuxtjs/composition-api';

export function useLastRefererCookie() {
    const {$cookies} = useContext();

    function initLastRefererCookie() {
        if (!process.client) {
            return;
        }

        const cookieName = 'CIBSITE_LAST_REFERER';
        const {referrer} = document;
        const cookieValue = $cookies.get(cookieName);

        if (cookieValue?.includes(window?.location?.host) || !referrer) {
            return;
        }

        const cookieOptions = {
            maxAge: 365 * 24 * 60 * 60,
        };

        $cookies.set(cookieName, referrer, cookieOptions);
    }

    return {
        initLastRefererCookie,
    };
};
